
/**
 * @import internal modules
 */
import Layout from "@apps-shared/layout/component";
import Breadcrumb from "@apps-widgets/breadcrumb/component";

import Delayed  from "@apps-widgets/delayed/component";
import InfosDelayed  from "@apps-widgets/infos-delayed/component";
import * as Utils from '@root-utils/index';
// import * as Lodash from 'lodash';
/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as Scrollbars from 'react-custom-scrollbars';


// component
const Component: React.FunctionComponent<any> = (props: any): any =>{
    
    const { content  } = props;
    
    
    const data: any = Utils.removeDuplicateObject(Utils.transformObjectToArray(content),"preprod");

    
    // react use Hook 
    
    const [openModal, setOpenModal] = React.useState(false);

    const onClose = ( event: any) => setOpenModal(false);

    /**
     * @function onDrop
     * @param event 
     */
    const onDrop = ( event: any) => {
        
        event.preventDefault();

        const confidence: any = document.querySelector("#svg-stats-confidence");
        const categ: any = document.querySelector("#svg-stats-categ");
        const temps: any = document.querySelector("#svg-stats-temps");
        const urlImage: any = document.querySelector("#cart-image")
        const items: any = JSON.parse(event.dataTransfer.getData("text"));
        
        if(confidence!== null || categ !== null || temps !== null || urlImage !== null ){

            confidence.innerHTML = (items.preprod.score_classif*100).toFixed(1) + "%";
            categ.innerHTML = items.preprod.pred_classif;
            temps.innerHTML = Math.ceil(items.preprod.pred_time) ;
            urlImage.src = items.preprod.image_url ;
        }
        /* ;*/
        // items.preprod.images_url
    }
    /**
     * @function onDragOver
     * @param event 
     */
    const onDragOver = ( event: any) => {
        
        event.preventDefault();
      
    }
    const scrollsDelayed = React.createRef<any>();

    const handleScroll = (event: any) => {
        

        const index: number = Number(scrollsDelayed.current.detectScrollingInterval);

        if(index < 500){ props.DelayedActionCreator(index);}
        

    }
    return(
        <Layout realTime={false} menu={true} timerShow={true} importImage={openModal} onClose={onClose} > 
            <Breadcrumb classnames="screen-width" title="Delayed" level0="delayed" level1="home" realTime={false}/>
            <section id="columns" className="with-1-3-columns">
                <div className="cart-items">
                    <div className="delayed-cart cart-content screen-width">
                        <li onDrop={onDrop} onDragOver={onDragOver}>
                            <div className="items-cart-images">
                                <span className="galery"/>
                                <div className="image-galery" >
                                    <img src="" alt="" id="cart-image"/>
                                </div>
                            </div> 
                            <InfosDelayed/>
                        </li>
                        <li>
                            <div className="items-images-images">
                                <span className="galery">Galerie</span>
                                <div className="list-image-galery">
                                    <Scrollbars.default autoHide={true} onScroll={handleScroll} ref={scrollsDelayed}>
                                        {
                                          data &&  data.map( ( items: any, index: number)=> <Delayed items={items} key={index}/>)
                                        }
                                    </Scrollbars.default> 
                                </div>
                                
                            </div>
                        </li>
                        
                    </div>
                </div>
                { false && <div className="screen-width">
                    <div className="import-btn">
                        <label className="fileContainer ">
                            Importer vos images
                            <input type="file"/>
                        </label>
                       
                    </div>
                </div>}
            </section>
        </Layout>
        
    )
}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@pages/delayed/component.tsx